<template>
    <div v-if="show" class="reg-pop relative">

        <div class="login-pop-title cf">

            <div class="fl">快速注册</div>

            <div class="fr go_login">已有账号，<span @click="open">去登录</span></div>

        </div>

        <div class="login-input login-margin cf">

            <img class="fl login-input-icon" src="./images/login_icon_user@2x.png" />

            <input class="fl" type="number" v-model="mobile" placeholder="请输入手机号码" />

        </div>

        <div class="reg-code login-margin cf">

            <img class="fl login-input-icon" src="./images/register_icon_verify@2x.png" />

            <input class="fl" type="number" v-model="code" placeholder="请输入验证码" />

            <div
                class="fr code-btn button-active pointer"
                :style="{ color: disabled ? '#d10916' : '#999999' }"
                @click="getCode"
            >{{ codeText }}</div>

        </div>

        <div class="login-input login-margin cf">

            <img class="fl login-input-icon" src="./images/login_icon_code@2x.png" />

            <input class="fl" :type="input_type1 ? 'password' : 'text'" v-model="password" placeholder="请设置登录密码" />

            <div class="eye fr" @click="input_type1 = !input_type1">

                <img v-if="input_type1" src="./images/sign_ico_eye_closed@2x.png" />

                <img v-else src="./images/sign_ico_eye_opened@2x.png" />

            </div>

        </div>

        <div class="login-input login-margin cf">

            <img class="fl login-input-icon" src="./images/login_icon_code@2x.png" />

            <input class="fl" :type="input_type2 ? 'password' : 'text'" v-model="reg_password" placeholder="请再次输入密码" />

            <div class="eye fr" @click="input_type2 = !input_type2">

                <img v-if="input_type2" src="./images/sign_ico_eye_closed@2x.png" />

                <img v-else src="./images/sign_ico_eye_opened@2x.png" />

            </div>

        </div>

        <div class="login-input cf">

            <img class="fl login-input-icon" src="./images/register_icon_invite@2x.png" />

            <input class="fl" type="text" v-model="invite" placeholder="请输入邀请码（选填）" />

        </div>

        <div class="login-btn button button-active" @click="reg">注册</div>

        <div class="reg-select cf">

            <div class="select-img fl" @click="is_select = !is_select">

                <img v-if="is_select" src="./images/sign_checkbox_s@2x.png" />

                <img v-else src="./images/sign_checkbox_n@2x.png" />

            </div>

            <div class="reg-select-text fl">
                我已阅读并同意
                <span @click="openUser">《用户协议》</span>
                <span @click="openPrivacy">《隐私协议》</span>
            </div>

        </div>

        <img
            class="close-pop absolute button-active"
            src="./images/sign_ico_closed@2x.png"
            @click.stop="close"
        />

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "layout-reg",
    mixins: [mixin],
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped src="./style.css"></style>
